import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Cookies } from "react-cookie";
import config from "../config";
var cookies = new Cookies();
var client = reconnect();

// Store message handlers as arrays to support multiple handlers per action
var messageHandlers = {};

function reconnect() {
  client = new W3CWebSocket(
    config.api.webSocketv2.baseUrl +
      "?x-client-fingerprint=" +
      cookies.get("fingerprint"),
  );
  client.onopen = () => {
    client.isOpen = true;
    console.log("WebSocket V2 Client Connected");
  };
  client.onclose = () => {
    client.isOpen = false;
    setTimeout(reconnect, 1000);
  };
  client.onmessage = (message) => {
    try {
      const data = JSON.parse(message.data);
      const action = data.action;

      // Call ALL registered handlers for this action
      if (messageHandlers[action]) {
        messageHandlers[action].forEach(handler => handler(data));
      }

      // Call ALL wildcard handlers
      if (messageHandlers["*"]) {
        messageHandlers["*"].forEach(handler => handler(data));
      }
    } catch (error) {
      console.error("Error parsing WebSocket message:", error);
    }
  };
  client.onerror = (error) => {
    console.error("WebSocket error:", error);
  };
  return client;
}

// Push handler into array instead of overwriting
export function onMessage(action, handler) {
  if (!messageHandlers[action]) {
    messageHandlers[action] = [];
  }
  messageHandlers[action].push(handler);
}

// Remove only the specific handler, not all handlers for the action
export function offMessage(action, handler) {
  if (!messageHandlers[action]) return;
  messageHandlers[action] = messageHandlers[action].filter(h => h !== handler);
}

export function sendMessage(action, data) {
  if (client && client.isOpen) {
    client.send(JSON.stringify({ action, data }));
  } else {
    console.warn("WebSocket not connected");
  }
}

export default client;